<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Tipo de Encuesta</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh">Tiempo Restante para Contestar</th>
                <th :class="StyleTh">Cantidad Encuestas Enviadas</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr>
                    <td class="text-center"><p :class="StyleTd">1</p></td>
                    <td><h6 :class="StylePr">Coordinador</h6></td>
                    <td>
                        <p v-show="!BndExistEncuestaCoordinador" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-danger">Encuesta no Configurada</span></p>
                        <p v-show="BndExistEncuestaCoordinador && !BndEncuestaCoordinador && !BndEncuestaRespondidaCoordinador" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-faded-warning">No Enviada</span></p>
                        <p v-show="!BndEncuestaRespondidaCoordinador && BndEncuestaCoordinador && !BndEncuestaExpiradaCoordinador" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-secondary">Sin Responder</span></p>
                        <p v-show="BndEncuestaCoordinador && BndEncuestaExpiradaCoordinador" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-danger">Encuesta Expirada</span></p>
                        <p v-show="BndEncuestaRespondidaCoordinador" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-faded-success">Contestada</span></p>
                    </td>
                    <td><p :class="StyleTd">{{ TiempoRestanteCoordinador }} Días</p></td>
                    <td><p :class="StyleTd">{{ ContadorEncuestaCoordinador }}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <button v-show="BndExistEncuestaCoordinador && !BndEncuestaRespondidaCoordinador" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="ConfirmarEnviarEncuesta('COORDINADOR',false)">
                                    <i class="fas fa-envelope text-primary me-2" aria-hidden="true"></i>{{ BndEncuestaCoordinador ? "Volver a Enviar Encuesta" : "Enviar Encuesta" }}
                                </button>
                                <button v-show="BndEncuestaRespondidaCoordinador" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="VerEncuesta('COORDINADOR')">
                                    <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i> Ver Encuesta
                                </button>
                                <button v-show="EnviarEncuestaSinExpirar&& BndExistEncuestaCoordinador && !BndEncuestaRespondidaCoordinador && BndEncuestaCoordinador" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="ConfirmarEnviarEncuesta('COORDINADOR',false)">
                                    <i class="fas fa-envelope text-primary me-2" aria-hidden="true"></i> Reenviar Encuesta
                                </button>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <tr>
                    <td class="text-center"><p :class="StyleTd">2</p></td>
                    <td><h6 :class="StylePr">Parejas</h6></td>
                    <td>
                        <p v-show="!BndExistEncuestaParejas" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-danger">Encuestas no Configuradas</span></p>
                        <p v-show="BndExistEncuestaParejas && !BndEncuestaParejas && !BndEncuestaRespondidaParejas" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-faded-warning">No Enviada</span></p>
                        <p v-show="!BndEncuestaRespondidaParejas && BndEncuestaParejas && !BndEncuestaExpiradaParejas" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-secondary">Sin Responder</span></p>
                        <p v-show="BndEncuestaParejas && BndEncuestaExpiradaParejas" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-danger">Encuesta Expirada</span></p>
                        <p v-show="BndEncuestaRespondidaParejas" class="text-xs text-secondary mb-0"><span class="badge badge-sm bg-gradient-faded-success">Contestada</span></p>
                    </td>
                    <td><p :class="StyleTd">{{ TiempoRestanteParejas }} Días</p></td>
                    <td><p :class="StyleTd">{{ ContadorEncuestaParejas }}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <template v-if="segurity.SendSurvey">
                                    <button v-show="BndExistEncuestaParejas && !BndEncuestaRespondidaParejas" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="ConfirmarEnviarEncuesta('PAREJAS',false)">
                                        <i class="fas fa-envelope text-primary me-2" aria-hidden="true"></i> {{ BndEncuestaParejas ? "Volver a Enviar Encuesta" : "Enviar Encuesta" }}
                                    </button>
                                </template>
                                <button v-show="BndEncuestaRespondidaParejas" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="VerEncuesta('PAREJAS')">
                                    <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i> Ver Encuesta
                                </button>
                                <button v-show="EnviarEncuestaSinExpirar && BndExistEncuestaParejas && BndEncuestaParejas && !BndEncuestaRespondidaParejas" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="ConfirmarEnviarEncuesta('PAREJAS',true)">
                                    <i class="fas fa-envelope text-primary me-2" aria-hidden="true"></i> Reenviar Encuesta
                                </button>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
            </template>
            <!-- <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="container-fluid">
                            <form id="EnviarEncuesta" role="form" method="post" autocomplete="off" onSubmit="return false">
                                <div class="row">
                                    <div class="col-lg-6 text-center">
                                        <h3>Coordinador</h3>
                                        <button v-show="!BndEncuestaRespondidaCoordinador" @click="ConfirmarEnviarEncuesta('COORDINADOR')" type="button" class="btn btn-primary"><i class="fa fa-envelope"></i> {{ BndEncuestaCoordinador ? "Volver a Enviar Encuesta" : "Enviar Envuesta"}}</button>
                                        <button v-show="BndEncuestaRespondidaCoordinador" @click="VerEncuesta('COORDINADOR')" type="button" class="btn btn-primary"><i class="fa fa-eye"></i> Ver Encuesta</button>
                                    </div>
                                    <div class="col-lg-6 text-center">
                                        <h3>Pareja</h3>
                                        <button v-show="!BndEncuestaRespondidaParejas" @click="ConfirmarEnviarEncuesta('PAREJAS')" type="button" class="btn btn-primary"><i class="fa fa-envelope"></i> {{ BndEncuestaParejas ? "Volver a Enviar Encuesta" : "Enviar Envuesta"}}</button>
                                        <button v-show="BndEncuestaRespondidaParejas" @click="VerEncuesta('PAREJAS')" type="button" class="btn btn-primary"><i class="fa fa-eye"></i> Ver Encuesta</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </template>
                </CLoader>
            </template> -->
        </CList>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta="EnviarEncuesta";
export default {
    name: 'ListaEncuesta',
    props: ['objEnviado'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Encuestas',
                IsModal: false,
                ShowLoader: true,
                ShowFiltros: false,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Prospectos',
                BtnNewShow:false,
                ShowPaginador:false
                // GoRoute: 'formCotizacion',
            },
            ConfigLoad:{
                ShowLoader:false,
                ClassLoad:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            objCliente:{},
            BndExistEncuestaCoordinador:false,
            BndExistEncuestaParejas:false,
            BndEncuestaCoordinador:false,
            BndEncuestaParejas:false,
            BndEncuestaRespondidaCoordinador:false,
            BndEncuestaRespondidaParejas:false,
            BndEncuestaExpiradaCoordinador:false,
            BndEncuestaExpiradaParejas:false,
            TiempoRestanteCoordinador:0,
            TiempoRestanteParejas:0,
            ContadorEncuestaCoordinador:0,
            ContadorEncuestaParejas:0,
            EnviarEncuestaSinExpirar:false
        }
    },
    methods: {
        async Guardar(TipoEncuesta,EnviarEncuestaSinExpirar){
            let formData=new FormData();
            formData.set('Tipo',TipoEncuesta);
            formData.set('IdContacto',this.objCliente.IdContacto);
            formData.set('IdCliente',this.objCliente.IdCliente);
            formData.set('PermitirEnviar',EnviarEncuestaSinExpirar);
            this.$http.post('/configEncuestasEnviar',formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.$toast.success("Encuesta Enviada");
            this.ListarEncuestas();
        },
        EjecutaConError(err){
            this.$toast.warning(err.response.data.message);
            this.ConfigLoad.ShowLoader=false;
        },
        Regresar(){
            this.$router.push({name:'prospectos',params:{}});
        },
        async RecuperarCotizacion(){
            await this.$http.get("/cotizacionesCliente/"+this.objCliente.IdCliente
            ).then((res)=>{
                this.objCliente=res.data.data;
                this.ListarEncuestas();
            })
        },
        async ListarEncuestas(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get('/encuestaResueltaK',{
                params:{
                    IdUsuario:this.objCliente.IdCliente,
                    IdContacto:this.objCliente.IdContacto,
                    Anio:new Date().getFullYear()
                }
            }).then((res)=>{
                this.BndExistEncuestaCoordinador=res.data.data.ExistEncuestaCoordinador;
                this.BndExistEncuestaParejas=res.data.data.ExistEncuestaParejas;
                this.BndEncuestaCoordinador=res.data.data.EncuestaTokenCoordinador;
                this.BndEncuestaParejas=res.data.data.EncuestaTokenParejas;
                this.BndEncuestaRespondidaCoordinador=res.data.data.EncuestaRespondidaCoordinador;
                this.BndEncuestaRespondidaParejas=res.data.data.EncuestaRespondidaParejas;
                this.BndEncuestaExpiradaCoordinador=res.data.data.EncuestaExpiradaCoordinador;
                this.BndEncuestaExpiradaParejas=res.data.data.EncuestaExpiradaParejas;
                this.TiempoRestanteCoordinador=res.data.data.DiasRestantesCoordinador;
                this.TiempoRestanteParejas=res.data.data.DiasRestantesParejas;
                this.ContadorEncuestaCoordinador=res.data.data.ContadorEncuestaCoordinador;
                this.ContadorEncuestaParejas=res.data.data.ContadorEncuestaParejas;
                
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        ConfirmarEnviarEncuesta(TipoEncuesta,EnviarEncuestaSinExpirar){
            this.$swal({
                title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea Enviar la encuesta?</h2>',
                text: 'Esta acción no se podra revertir ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result)=>{
                if (result.value) {
                    this.Guardar(TipoEncuesta,EnviarEncuestaSinExpirar);
                }
            })
        },
        VerEncuesta(Tipo){
            this.objCliente.TipoEncuesta=Tipo;
            this.$router.push({name:'encuestaRespuestas',params:{objEnviado:this.objCliente}});
        }
    },
    created() {
        if (this.objEnviado!=undefined) {
            sessionStorage.setItem('objCliente',JSON.stringify(this.objEnviado));
        }
        this.objCliente=JSON.parse(sessionStorage.getItem('objCliente'));
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.RecuperarCotizacion();
        // this.ListarEncuestas();
        this.bus.$on('EmitReturn',()=>{
            this.Regresar();
        })
    },
}
</script>

<style>

</style>